import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { UnpaidInvoicesPayBoPage } from '../../../../../../components/pages/unpaid-invoices-recovery/unpaid-invoices-pay-bo-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

const searchSchema = type({ invoices: 'string[]' })

export const Route = createFileRoute('/bo/users/$userId_/unpaid-invoices/payment')({
  validateSearch: searchSchema,
  component: function Component() {
    const { userId } = Route.useParams()
    const { invoices } = Route.useSearch()
    return (
      <PermissionChecker requiredPermissions={[anyOfPermissions('invoice.pay', 'invoice.pay.managedByOrusOnly')]}>
        <UnpaidInvoicesPayBoPage userId={userId} invoices={invoices} />
      </PermissionChecker>
    )
  },
})
